exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.inline-promo350 {\n    width: 450px !important;\n    overflow: visible;\n    text-overflow: ellipsis;\n}\n.table-wrapper .custom-table-wrapper.manual-promotion-body {\n    overflow: unset !important;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/SideMenu/Promotion/ManualPromotion.vue"],"names":[],"mappings":";AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;CAC3B;AACD;IACI,2BAA2B;CAC9B","file":"ManualPromotion.vue","sourcesContent":["\n.inline-promo350 {\n    width: 450px !important;\n    overflow: visible;\n    text-overflow: ellipsis;\n}\n.table-wrapper .custom-table-wrapper.manual-promotion-body {\n    overflow: unset !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56681ddf","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/Promotion/ManualPromotion.vue
// module id = K2r6
// module chunks = 2